/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  carousel: Item<'Carousel'>;
  flexPanel2: Item<'FlexPanel'>;
  flexItem2: Item<'FlexItem'>;
  typography2: Item<'Typography'>;
  flexPanel3: Item<'FlexPanel'>;
  flexItem3: Item<'FlexItem'>;
  typography3: Item<'Typography'>;
} = {
  root: {
    children: ['carousel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  carousel: {
    children: ['flexPanel2', 'flexPanel3'],
    itemId: 'carousel',
    parent: 'root',
    props: {
      autoPlay: false,
      interval: 3000,
      stopOnHover: true,
      infiniteLoop: true,
      showArrows: true,
      showStatus: true,
      showIndicators: true,
      useKeyboardArrows: true,
      emulateTouch: true,
      selectedItem: 0,
      transitionTime: 350,
      indicatorColor: {
        type: 'expression',
        value: 'primary',
      },
    },
    type: 'Carousel',
  },
  flexPanel2: {
    children: ['flexItem2'],
    itemId: 'flexPanel2',
    parent: 'carousel',
    props: {},
    type: 'FlexPanel',
  },
  flexItem2: {
    children: ['typography2'],
    itemId: 'flexItem2',
    parent: 'flexPanel2',
    props: {},
    type: 'FlexItem',
  },
  typography2: {
    children: [],
    itemId: 'typography2',
    parent: 'box',
    props: {
      text: {
        type: 'text',
        value: 'Slide 1 - First carousel item',
      },
      variant: 'h5',
    },
    type: 'Typography',
  },
  flexPanel3: {
    children: ['flexItem3'],
    itemId: 'flexPanel3',
    parent: 'carousel',
    props: {},
    type: 'FlexPanel',
  },
  flexItem3: {
    children: ['typography3'],
    itemId: 'flexItem3',
    parent: 'flexPanel3',
    props: {},
    type: 'FlexItem',
  },
  typography3: {
    children: [],
    itemId: 'typography3',
    parent: 'flexItem3',
    props: {
      text: {
        type: 'text',
        value: 'Slide 2 - Second carousel item',
      },
      variant: 'h5',
    },
    type: 'Typography',
  },
};
